// src/utils/userData.js
import { doc, setDoc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

// Crear documento si no existe y guardar datos base
export const createUserData = async (user) => {
  const ref = doc(db, "users", user.uid);
  await setDoc(
    ref,
    {
      uid: user.uid,
      name: user.displayName || null,
      email: user.email || null,
	  phone: user.phoneNumber || null,
      photoURL: user.photoURL || null,
      progress: 0,
      score: 0,
      favorites: [],
      createdAt: new Date(),
    },
    { merge: true } // merge para no sobrescribir si ya existe
  );
};

// Obtener los datos de un usuario
export const getUserData = async (uid) => {
  const ref = doc(db, "users", uid);
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
};

// Actualizar campos específicos (puntuación, favoritos, etc.)
export const updateUserData = async (uid, newData) => {
  const ref = doc(db, "users", uid);
  await updateDoc(ref, newData);
};
